import {useSuspenseQuery} from "@tanstack/react-query";

import {getClientQueryOptions} from "./get-client.query-options";

export function useGetClient(id: string, includeDeleted = false) {
  return useSuspenseQuery(getClientQueryOptions(id, includeDeleted));
}
